( function( $ ) {
	function getCloneCount( $container ) {
		const $slide = $container.find( '.slide' );
		const slideWidth = $slide.outerWidth();
		const sliderWidth = $container.outerWidth();
		const numberOfSlides = $slide.length;
		const requiredNumberOfSlides = Math.ceil( sliderWidth / slideWidth ) * 2;
		const result = Math.ceil( requiredNumberOfSlides / numberOfSlides ) - 1;

		return result < 1 ? 1 : result;
	}

	function initBlock( section = false ) {
		const $section = section ? $( section ) : $( '.section-partners' );

		const $infiniteslider = $section.find( '.js-partners-infiniteslide' );

		$section.find( '.infiniteslide_wrap' ).replaceWith( function() {
			return $( $infiniteslider, this );
		} );		

		$infiniteslider.find( '.infiniteslide_clone' ).remove();
		$infiniteslider.find( '.slide' ).removeAttr( 'style' );
		$infiniteslider.removeAttr( 'style' );
		$infiniteslider.removeAttr( 'data-style' ); 
		
		$infiniteslider.each( function() {
			const $container = $( this );
		
			const sliderCall = () => {
				const loadInfiniteslide = () => {
					$container.infiniteslide( {
						'speed': 50, //speed this is px/min
						'direction': 'left', //choose  up/down/left/right
						'pauseonhover': true, //if true,stop onmouseover
						'responsive': false, //width/height recalculation on window resize. child element's width/height define %/vw/vh,this set true.
						'clone': getCloneCount( $container ) + 2 //if child elements are too few (elements can't "infinite"), set 2 or over.
					} );

				};

				window.app.loadVendor( 'Infiniteslide', loadInfiniteslide );
			};
					
			let containerOuterWidth = $container.outerWidth();
			let shadeWidth = 140;
			let shadeBreakpoints = [
				{
					width: 1921,
					shadeWidth: 340
				},
				{
					width: 1720,
					shadeWidth: 224
				},
				{
					width: 1280,
					shadeWidth: 140
				},                
				{
					width: 1025,
					shadeWidth: 74
				},                                                    
				{
					width: 768,
					shadeWidth: 55
				},
			];
		
			shadeBreakpoints.forEach( ( shadeBreakpoint ) => {
				if ( containerOuterWidth < shadeBreakpoint.width ) {
					shadeWidth = shadeBreakpoint.shadeWidth;
				}
			} );
		
			if ( containerOuterWidth <= $container.find( '.slide' ).length * $container.find( '.slide:first-child' ).outerWidth() + ( shadeWidth * 2 ) ) {
				sliderCall();
			}            
		} );
	}

	window.app.loadBlock( initBlock, 'section-partners', '.section-partners' );
} )( jQuery );